module.exports = __webpack_public_path__ + "img/1.f7c10075.png";